<template>
  <transition name="slide-y-reverse-transition">
    <v-card max-height="240px" style="overflow: scroll" class="mt-2">
      <v-card-text class="text-xs-center">
        <strong style="font-size: 18px">Order log history</strong>
      </v-card-text>
      <v-flex class="text-xs-left">
        <v-data-table
          :headers="headers"
          :items="order_detail.order_log"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">
              {{ order_detail.order_log.indexOf(props.item) + 1 }}
            </td>
            <td class="text-xs-center">{{ moment(props.item.create_at) }}</td>
            <td class="text-xs-center">
              {{ props.item.order_log_user_name }}
            </td>
            <td class="text-xs-center">{{ props.item.order_log_name }}</td>
          </template>
          <template slot="no-data">
            <center>No order log history yet.</center>
          </template>
        </v-data-table>
      </v-flex>
    </v-card>
  </transition>
</template>

<script>
export default {
  props: ["order_detail"],
  data() {
    return {
      headers: [
        { text: "No.", align: "center", sortable: false, value: "num" },
        { text: "Date/Time", value: "date", sortable: false, align: "center" },
        { text: "User", value: "user", sortable: false, align: "center" },
        { text: "Action", value: "user", sortable: false, align: "center" },
      ],
    };
  },
};
</script>

<style></style>
